import { AxiosPromise } from 'axios';
import { libApiInstance } from '../axios';
import { CreateStripeSessionRequest } from './types/createStripeSessionRequest';
import { CreateStripeSessionResponse } from './types/CreateStripeSessionResponse';

export function requestStripeUrl(
    offerKey: CreateStripeSessionRequest,
    signal?: AbortSignal,
): AxiosPromise<CreateStripeSessionResponse> {
    return libApiInstance.post(`/account/billing/stripe`, offerKey, { signal });
}
